import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BookmarkPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useSavedSearches } from '@/hooks/useSavedSearches';
import { toast } from '@/hooks/use-toast';

/** Gemmer den aktuelle filtrering som en navngiven søgning. */
export function SaveSearchButton({ defaultName }: { defaultName?: string }) {
  const location = useLocation();
  const { saveSearch, isSaving, isLoggedIn } = useSavedSearches();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(defaultName || '');

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="gap-2"
        onClick={() => {
          if (!isLoggedIn) {
            toast({ title: 'Log ind for at gemme søgninger', variant: 'destructive' });
            return;
          }
          setName(defaultName || 'Min søgning');
          setOpen(true);
        }}
      >
        <BookmarkPlus className="w-4 h-4" aria-hidden />
        Gem søgning
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Gem søgning</DialogTitle>
            <DialogDescription>
              Dine filtre gemmes, så du kan hente den samme søgning frem igen fra "Mine biler".
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-2">
            <Label htmlFor="search-name">Navn</Label>
            <Input
              id="search-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="fx SUV under 400.000 kr."
            />
          </div>

          <DialogFooter>
            <Button
              disabled={isSaving || !name.trim()}
              onClick={() => {
                saveSearch({ name: name.trim(), queryString: location.search });
                setOpen(false);
              }}
            >
              Gem
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
